// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as ErrorBoundary$OrcaPaymentPage from "./ErrorBoundary.bs.js";

function ReusableReactSuspense(props) {
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.keys);
  return JsxRuntime.jsx(ErrorBoundary$OrcaPaymentPage.make, {
    children: JsxRuntime.jsx(React.Suspense, {
      children: props.children,
      fallback: props.loaderComponent
    }),
    level: "PaymentMethod",
    componentName: props.componentName,
    publishableKey: match.publishableKey
  });
}

let make = ReusableReactSuspense;

export {
  make,
}
/* jotai Not a pure module */
